import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { FiChevronRight } from 'react-icons/fi'
import { Column, Row } from 'components/common/layout'
import {
  SemiBold14Text,
  SemiBoldH5Text,
} from 'components/resume-analyzer/styles'
import { useIsDesktop } from 'utils/hooks'
import Image from 'next/legacy/image'

export const MarketingContentsBanner: React.FC = () => {
  const router = useRouter()

  return (
    <BannerCard onClick={() => router.push('/scouts/my-profile')}>
      <Column style={{ gap: 2, textAlign: 'start' }}>
        <SemiBold14Text>
          내 이력서로 바로 스카웃 제안 받아보세요!
        </SemiBold14Text>
        <SemiBoldH5Text>그룹바이에 프로필 등록하기</SemiBoldH5Text>
      </Column>
      <FiChevronRight size={28} />
    </BannerCard>
  )
}

export const MarketingImageBanner: React.FC<{ url: string }> = ({ url }) => {
  const isDesktop = useIsDesktop()
  return (
    <a href={url} target='_blank'>
      {isDesktop ? (
        <Image
          src='/viral-marketing-banner.png'
          alt='banner'
          layout='responsive'
          objectFit='contain'
          width={1925}
          height={903}
        />
      ) : (
        <Image
          src='/viral-marketing-banner-2.png'
          alt='banner'
          layout='responsive'
          objectFit='contain'
          width={1080}
          height={2088}
        />
      )}
    </a>
  )
}

const BannerCard = styled(Row)`
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 16px 24px;
  position: sticky;
  justify-content: space-between;
  background: ${(p) => p.theme.color.linear};
  cursor: pointer;
  span,
  svg {
    color: ${(p) => p.theme.color.white1};
  }
`
